<div class="main-content" *ngIf="canRead()">

  <!-- ─── HEADER ─── -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--red">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <div>
        <h1 class="main-title">Lista Discrepanze</h1>
        <p class="main-subtitle">Analisi e gestione delle discrepanze nelle spedizioni</p>
      </div>
    </div>
    <div class="d-flex gap-2">
      <!-- <button type="button" class="btn btn-primary"
              (click)="sendLoadedToClient()"
              [disabled]="isSendingLoaded">
        <i class="fas me-2" [ngClass]="isSendingLoaded ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
        {{ isSendingLoaded ? 'Invio in corso...' : 'Invia caricato al cliente' }}
      </button>
      <button type="button" class="btn btn-outline-primary"
              (click)="importDdtAttachments()"
              [disabled]="isImportingDdtAttachments">
        <i class="fas me-2" [ngClass]="isImportingDdtAttachments ? 'fa-spinner fa-spin' : 'fa-file-import'"></i>
        {{ isImportingDdtAttachments ? 'Import in corso...' : 'Importa allegati DDT' }}
      </button>
      <button type="button" class="btn btn-outline-primary"
              (click)="exportXmlToFolder()"
              [disabled]="isExportingXml">
        <i class="fas me-2" [ngClass]="isExportingXml ? 'fa-spinner fa-spin' : 'fa-file-code'"></i>
        {{ isExportingXml ? 'Export in corso...' : 'Esporta XML' }}
      </button>
       <button type="button" class="btn btn-outline-primary"
              (click)="sendUpdatesToClient()"
              [disabled]="isSendingUpdates">
        <i class="fas me-2" [ngClass]="isSendingUpdates ? 'fa-spinner fa-spin' : 'fa-cloud-upload-alt'"></i>
        {{ isSendingUpdates ? 'Invio in corso...' : 'Invia update al cliente' }}
      </button>
      <button type="button" class="btn btn-outline-primary"
              (click)="sendShipments()"
              [disabled]="isSendingShipments">
        <i class="fas me-2" [ngClass]="isSendingShipments ? 'fa-spinner fa-spin' : 'fa-box'"></i>
        {{ isSendingShipments ? 'Invio in corso...' : 'Invia Shipments' }}
      </button>
      <button type="button" class="btn btn-outline-primary"
              (click)="sendClaims()"
              [disabled]="isSendingClaims">
        <i class="fas me-2" [ngClass]="isSendingClaims ? 'fa-spinner fa-spin' : 'fa-pallet'"></i>
        {{ isSendingClaims ? 'Invio in corso...' : 'Invia Claims' }}
      </button>
      <button type="button" class="btn btn-outline-primary"
              (click)="sendReasonCode()"
              [disabled]="isSendingReasonCode">
        <i class="fas me-2" [ngClass]="isSendingReasonCode ? 'fa-spinner fa-spin' : 'fa-tags'"></i>
        {{ isSendingReasonCode ? 'Invio in corso...' : 'Invia Reason Code' }}
      </button> -->
    </div>
  </div>

  <!-- ─── SEZIONE 1: FILTRI & SELEZIONE VELOCE ─── -->
  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri &amp; Selezione Veloce</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleFiltersCollapsed()"
                [title]="isFiltersCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isFiltersCollapsed">

      <!-- Quickset per cliente (da /configuration) -->
      <div class="filter-group mb-4" *ngIf="configClients.length > 0">
        <h6 class="filter-group-title">
          <i class="fas fa-bolt me-1 text-warning"></i> Selezione Veloce
        </h6>
        <div class="quickset-buttons">
          <button type="button" class="quickset-btn"
                  *ngFor="let client of configClients"
                  [class.quickset-btn--active]="selectedClientCode === client.code"
                  (click)="applyClientQuickset(client)">
            <i class="fas fa-user"></i>
            <span>{{ client.name }}</span>
          </button>
        </div>
      </div>

      <!-- Periodo + Cliente + Piattaforma -->
      <div class="row g-3 mb-3">
        <div class="col-md-3">
          <label class="form-label">Periodo Da *</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-alt filter-icon"></i>
            <input #dateFromInput type="text" class="filter-input" placeholder="gg/mm/aaaa hh:mm" readonly>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Periodo A *</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-alt filter-icon"></i>
            <input #dateToInput type="text" class="filter-input" placeholder="gg/mm/aaaa hh:mm" readonly>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Cliente</label>
          <app-searchable-select
                  [class.field-flash]="flashClient"
                  [(ngModel)]="selectedClientCode"
                  [options]="clientSelectOptions"
                  allOptionLabel="Tutti i clienti"
                  icon="fas fa-users"
                  searchPlaceholder="Cerca cliente..."
                  (valueChange)="onClientChange()">
          </app-searchable-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Piattaforma</label>
          <app-searchable-select
                  [class.field-flash]="flashWarehouse"
                  [(ngModel)]="selectedWarehouseCode"
                  [options]="warehouseSelectOptions"
                  allOptionLabel="Tutte le piattaforme"
                  icon="fas fa-warehouse"
                  searchPlaceholder="Cerca piattaforma...">
          </app-searchable-select>
        </div>
      </div>

      <!-- Azioni -->
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="resetFilters()">
          <i class="fas fa-undo me-1"></i> Reimposta
        </button>
        <button class="btn btn-primary btn-sm" type="button" (click)="search()" [disabled]="isLoading">
          <i class="fas me-1" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
          Cerca
        </button>
      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 2: RESOCONTO ─── -->
  <div id="summary-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Resoconto</h3>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-sm btn-outline-success"
                  (click)="downloadExcel()" [disabled]="isDownloadingExcel"
                  title="Scarica Lista Discrepanze">
            <i class="fas me-1" [ngClass]="isDownloadingExcel ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>
            Lista Discrepanze
          </button>
          <button type="button" class="btn btn-sm btn-outline-primary"
                  (click)="downloadImages()" [disabled]="isDownloadingImages"
                  title="Scarica Immagini">
            <i class="fas me-1" [ngClass]="isDownloadingImages ? 'fa-spinner fa-spin' : 'fa-images'"></i>
            Immagini
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="toggleReportCollapsed()"
                  [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
            <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body" *ngIf="!isReportCollapsed">

      <!-- Error -->
      <div class="alert alert-danger" *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle me-2"></i>{{ errorMessage }}
      </div>

      <div class="dl-metrics-grid">

        <div class="dl-metric-card">
          <div class="dl-metric-icon dl-metric-icon--blue">
            <i class="fas fa-truck-loading"></i>
          </div>
          <div class="dl-metric-body">
            <div class="dl-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.colliAffidati | number }}</ng-container>
            </div>
            <div class="dl-metric-label">Colli Affidati</div>
          </div>
        </div>

        <div class="dl-metric-card">
          <div class="dl-metric-icon dl-metric-icon--green">
            <i class="fas fa-box-open"></i>
          </div>
          <div class="dl-metric-body">
            <div class="dl-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.colliPickerati | number }}</ng-container>
            </div>
            <div class="dl-metric-label">Colli Pickerati</div>
          </div>
        </div>

        <div class="dl-metric-card">
          <div class="dl-metric-icon dl-metric-icon--yellow">
            <i class="fas fa-clock"></i>
          </div>
          <div class="dl-metric-body">
            <div class="dl-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.colliNonPickerati | number }}</ng-container>
            </div>
            <div class="dl-metric-label">Colli Non Pickerati</div>
          </div>
        </div>

        <div class="dl-metric-card">
          <div class="dl-metric-icon dl-metric-icon--orange">
            <i class="fas fa-times-circle"></i>
          </div>
          <div class="dl-metric-body">
            <div class="dl-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.colliNonAffidati | number }}</ng-container>
            </div>
            <div class="dl-metric-label">Colli Non Affidati</div>
          </div>
        </div>

        <div class="dl-metric-card">
          <div class="dl-metric-icon dl-metric-icon--red">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="dl-metric-body">
            <div class="dl-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.colliDanneggiati | number }}</ng-container>
            </div>
            <div class="dl-metric-label">Colli Danneggiati</div>
          </div>
        </div>

        <div class="dl-metric-card">
          <div class="dl-metric-icon dl-metric-icon--purple">
            <i class="fas fa-images"></i>
          </div>
          <div class="dl-metric-body">
            <div class="dl-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.immaginiDisponibili | number }}</ng-container>
            </div>
            <div class="dl-metric-label">Immagini Disponibili</div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<!-- Accesso negato -->
<div class="text-center py-5" *ngIf="!canRead()">
  <i class="fas fa-lock fa-3x text-muted mb-3"></i>
  <h5 class="text-muted">Accesso negato</h5>
  <p class="text-muted">Non hai i permessi per visualizzare questa sezione.</p>
</div>
